import { render, staticRenderFns } from "./full-width-slider.vue?vue&type=template&id=151c8865"
import script from "./full-width-slider.vue?vue&type=script&lang=js"
export * from "./full-width-slider.vue?vue&type=script&lang=js"
import style0 from "./full-width-slider.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports